import * as React from 'react';
import {Item} from '../item.class';
import {Badge} from '../../ui/Badges/Badge';

type BadgesProps = {
    item: Item;
};
export const Badges = ({item}: BadgesProps) => {
    return (
        <>
            {item.isPurchased && (
                <Badge
                    className="tw-mr-2"
                    smallBadge={true}
                    variant="success"
                >
                    Purchased
                </Badge>
            )}
            {item.isBestSeller_b && !item.isPurchased && (
                <Badge
                    className="tw-mr-2"
                    smallBadge={true}
                    variant="warning"
                >
                    Best Seller
                </Badge>
            )}
            {item.isNew && !item.isJustAdded && !item.isBestSeller_b && !item.isPurchased && (
                <Badge
                    className="tw-mr-2"
                    smallBadge={true}
                    variant="danger"
                >
                    New
                </Badge>
            )}
            {item.isJustAdded && !item.isBestSeller_b && !item.isPurchased && (
                <Badge
                    className="tw-mr-2"
                    smallBadge={true}
                    variant="danger"
                >
                    Just Added
                </Badge>
            )}
            {item.binLocation && (
                <Badge
                    smallBadge={true}
                    variant="light"
                >
                    Location: {item.binLocation}
                </Badge>
            )}
        </>
    );
};
